module.exports = __webpack_public_path__ + "img/Lieblingsbeschäftigung.1accf4f2.svg";